module.exports = __webpack_public_path__ + "img/arie_no.c3ce2bc8.png";